export default {
  loginFailure: '登录失败！',
  language: '语 言',
  loginTitle: '利欧光伏水泵远程监控系统',
  company: '利欧集团泵业有限公司',
  ruleName1: '用户名不能为空',
  ruleName2: '4到20位,首字母不能为数字,不能有特殊字符',
  rulePwd: '密码不能为空',
  ruleCode1: '验证码不能为空',
  tipCode: '验证码错误',
  rulePhone1: '手机号不能为空',
  rulePhone2: '请输入合法的手机格式',
  ruleCode2: '请输入六位数字',
  loginByUser: '用户名登录',
  loginByPhone: '短信登录',
  user: '请输入用户名',
  password: '请输入密码',
  checkCode: '校验码',
  rememberPwd: '记住密码',
  login: '登 录',
  phoneNumber: '手机号',
  SMSCode: '短信验证码',
  getCode: '获取验证码',
  toLogin: '欢迎登录',
  input: '请输入',
  Ltd: '浙江信息技术有限公司',
  Ch: '中文',
  En: 'English',
  scanningInstructions: '温馨提示：建议打开手机浏览器扫一扫下载APP',
  register: '免费注册',
  reset: '忘记密码？'
}
